// "Add to a Route" candidates: Route RECORDS, not connections. A connection
// entry describes the provider and carries the UNION of destinations across
// all its Routes, so filtering on it hid eligible Routes and attaching used
// whichever Route happened to be first. A record knows its own destinations.
export const eligibleRoutes = (
  routes: any[],
  connectionId: string | undefined,
  workspaceId?: string,
) => {
  // The routes endpoint has no owner filter, so the workspace narrowing
  // happens here on the page that was fetched.
  const inWorkspace =
    workspaceId !== undefined
      ? routes.filter(
          (r: any) => r?.owner === workspaceId || r?.owner?.id === workspaceId,
        )
      : routes;
  // A Route can't receive data from its own provider, and re-adding a
  // destination it already has would be a no-op — hide both.
  return inWorkspace.filter(
    (r: any) =>
      !(r?.data_providers || []).some((p: any) => p?.id === connectionId) &&
      !(r?.destinations || []).some((d: any) => d?.id === connectionId),
  );
};
